import { useState } from "react";
import { CircularProgress, Paper, Popper } from "@mui/material";
import ClientService from "../../services/clients/ClientService";
import QuickSummaryIcon from "../../assets/interaction-detail-page/Extractive Summary Active.svg";

interface Props {
  orgId: string;
  subOrgId: string;
}

const QuickTopicsPopper = ({ orgId, subOrgId }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setTimeout(() => setOpen(false), 150);
  };

  const { data, isLoading, isFetching, isSuccess, isError, error } = ClientService.useGetClientQuickTopics(
    { orgId, subOrgId },
    open
  );

  const isActive = open;
  return (
    <>
      <div
        className={`hover-icon ${isActive ? "active" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img src={QuickSummaryIcon} width={16} />
      </div>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="right-start"
        style={{ zIndex: 1300 }}
      >
        <div
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={handleMouseLeave}
        >
          <Paper
            elevation={3}
            className="quick-topics-popper-box"
          >
            <div className="quick-topics-header">
              Concerning Topics
            </div>

            {(isLoading || isFetching) ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress size={20} />
              </div>
            ) : isError ? (
              <div style={{ fontSize: "12px" }}>
                {(error as any)?.response?.data?.message || (error as Error)?.message || "Failed to load topics"}
              </div>
            ) : isSuccess && data?.data?.length ? (
              <div>
                {data.data.map((topic: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      fontSize: "12px",
                      padding: "4px 0",
                    }}
                  >
                    • {topic}
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: "12px", color: "#888" }}>
                No topics
              </div>
            )}
          </Paper>
        </div>
      </Popper>
    </>
  );
};

export default QuickTopicsPopper;